export const MOBILE_MAX_SIZE = 799;
export const MEDIUM_MAX_SIZE = 1024;
export const LAPTOP_MAX_SIZE = 1440;
